import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ChatService } from 'app/services/chat.service';
import { AppModalService } from 'app/services/appModal.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[chatHeight]'
})
export class ChatHeightDirective implements OnInit {

  @Input() modalController: ModalController;
  @Output() breakpointChange = new EventEmitter<void>();
  public constructor(
    private el: ElementRef,
    private chatService: ChatService,
    private modalService: AppModalService
  ) {
  }

  public ngOnInit() {
    if (this.modalController) {
      this.modalController.getTop().then(modal => {
        modal.addEventListener('ionBreakpointDidChange', (e) => {
          this.checkSize();
          this.breakpointChange.emit();
        });

        // wtf is this
        // modal.onWillDismiss().then(_ => {
        //   this.chatService.showFixedChatInput = false;
        //   for (let i = 0; i < this.modalService.modalInst.length; i++) {
        //     this.modalService.modalInst[i].dismiss(undefined, 'hardClose');
        //   }
        //   this.modalService.modalInst = [];
        //   this.modalService.modalIncr = 0;
        // });
      });
    }
  }

  checkSize() {
    const rect = this.el.nativeElement?.getBoundingClientRect();
    this.el.nativeElement.style.height = window.innerHeight - rect.top - 1 + 'px';
  }
}
